import React, {useContext} from 'react';
import EmbedIframe from '~/src/components/embed/iframe/EmbedIframe';
import EmbedBlocker from '~/src/components/embed/blocker/Blocker';
import {ConsentContext} from '~/src/components/context/ConsentContext';

import css from './EmbedContent.module.scss';

const EmbedContent = ({content}) => {
    const consent = useContext(ConsentContext);

    if (!consent.allowsAll) {
        return <EmbedBlocker />;
    }

    return (
        <div className={css.content}>
            <EmbedIframe {...content.embed} />
        </div>
    );
};

export default EmbedContent;
